import _ from 'lodash';
import deviceApi from '../../utils/api/devices';
import { APPS } from '../../queries/queries';
import { setStorageItem, removeStorageItem } from '../../helpers/persistence';

const state = {
  deviceInterval: null,
  deviceList: [],
  device: null,
  deviceData: null,
  chartData: null,
  batteryQty: null,
  apiVersion: null,
  assignedTechnicians: null
};

const mutations = {
  SET_DEVICE_INTERVAL: (state, deviceInterval) => {
    state.deviceInterval = deviceInterval;
  },
  SET_DEVICE_LIST(state, deviceList) {
    state.deviceList = deviceList;
    setStorageItem('totalDevices', deviceList.length);
  },
  SET_DEVICE(state, device) {
    state.device = device;
    setStorageItem('currentDevice', device);
  },
  SET_DEVICE_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.deviceData = data;
  },
  SET_CHART_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.chartData = data;
  },
  SET_BATTERY_QTY(stateParam, data) {
    const innerState = stateParam;
    innerState.batteryQty = data;
  },
  SET_API_VERSION(stateParam, data) {
    const innerState = stateParam;
    innerState.apiVersion = data;
  },
  SET_ASSIGNED_TECHNICIANS(stateParam, data) {
    const innerState = stateParam;
    innerState.assignedTechnicians = data;
  }
};

const actions = {
  setDeviceInterval(context, value) {
    context.commit('SET_DEVICE_INTERVAL', value);
  },

  setDevice(context, value) {
    context.commit('SET_DEVICE', value);
  },

  loadDeviceList({ commit }) {
    return deviceApi
      .getDevices()
      .then(response => {
        commit('SET_DEVICE_LIST', response);
        if (response.length == 1) {
          commit('SET_DEVICE', response[0]);
        }
        return response;
      })
      .catch(err => {
        console.error('Devices::loadDeviceList()', err);
        commit('SET_DEVICE_LIST', []);
        return [];
      });
  },

  getDeviceWithSn({ commit }, sn) {
    return deviceApi
      .getDeviceWithSn(sn)
      .then(device => {
        if (device) commit('SET_DEVICE', device);
      })
      .catch(err => {
        console.error('Devices::getDeviceWithSn()', err);
        commit('SET_DEVICE', null);
        return [];
      });
  },

  submitAddressToDevice({ dispatch }, configObj) {
    return deviceApi
      .submitAddressToDevice(configObj)
      .then(() => {
        dispatch('getDeviceWithSn', configObj.serial);
      })
      .catch(err => {
        console.error('Devices::submitAddressToDevice()', err);
        return err;
      });
  },

  getDeviceData({ commit }, sn) {
    return deviceApi
      .getDeviceData(sn, APPS)
      .then(deviceData => {
        commit('SET_DEVICE_DATA', deviceData);
      })
      .catch(err => {
        console.error('Devices::getDeviceData()', err);
        commit('SET_DEVICE_DATA', null);
        return [];
      });
  },

  getBatteryQty({ commit }, sn) {
    const apps = ['LG_BATTERY_APP'];
    return deviceApi
      .getBatteryQty(sn, apps)
      .then(data => {
        let qty = 1;
        if (_.find(data, 'parameters.Number_of_Modules')) {
          qty = data[0].parameters.Number_of_Modules;
        }
        commit('SET_BATTERY_QTY', qty);
      })
      .catch(err => {
        console.error('Devices::getBatteryQty()', err);
        commit('SET_BATTERY_QTY', null);
        return [];
      });
  },

  getApiVersion({ commit }) {
    return deviceApi
      .getApiVersion()
      .then(version => {
        commit('SET_API_VERSION', version);
        return version;
      })
      .catch(err => {
        console.error('Devices::getApiVersion()', err);
        commit('SET_API_VERSION', null);
        return [];
      });
  },

  assignDeviceToTechnician(_, payLoad) {
    return deviceApi.assignDeviceToTechnician(payLoad).catch(err => {
      console.info('actions::assignDeviceToTechnician() - Error:', err);
      // Throw so that we can hook into the catch block
      throw err;
    });
  },

  getTechnicianList({ commit }, payLoad) {
    return deviceApi
      .getTechnicianList(payLoad)
      .then(data => {
        commit('SET_ASSIGNED_TECHNICIANS', data);
      })
      .catch(err => {
        console.info('actions::getTechnicianList() - Error:', err);
        // Throw so that we can hook into the catch block
        throw err;
      });
  },

  revokeTechnicianAccess(_, payLoad) {
    return deviceApi.revokeTechnicianAccess(payLoad).catch(err => {
      console.info('actions::revokeTechnicianAccess() - Error:', err);
      // Throw so that we can hook into the catch block
      throw err;
    });
  },

  submitExpertSettings(_, configObj) {
    console.log('SubmitExpertViewSettings', configObj);
    return deviceApi.submitExpertSettings(configObj).catch(err => {
      console.info('actions::submitExpertSettings() - Error:', err);
      // Throw so that we can hook into the catch block
      throw err;
    });
  },

  getEmailPeriodStats(_, configObj) {
    return deviceApi.getEmailPeriodStats(configObj).catch(err => {
      console.info('actions::getEmailPeriodStats() - Error:', err);
      // Throw so that we can hook into the catch block
      throw err;
    });
  },

  clearDevices({ commit }) {
    commit('SET_DEVICE_LIST', []);
    commit('SET_DEVICE_DATA', null);
    commit('SET_DEVICE', null);
    commit('SET_ASSIGNED_TECHNICIANS', null);
    removeStorageItem('currentDevice');
  }
};

const getters = {
  deviceInterval: state => state.deviceInterval,
  deviceList: state => state.deviceList,
  device: state => state.device,
  deviceData: state => state.deviceData,
  chartData: state => state.chartData,
  batteryQty: state => state.batteryQty,
  apiVersion: state => state.apiVersion,
  assignedTechnicians: state => state.assignedTechnicians
};

export default {
  state,
  mutations,
  actions,
  getters
};
